import { useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Instagram, Facebook } from 'lucide-react';
import { Separator } from '../ui/separator';

const navigationLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '#about' },
  { label: 'Features', href: '#features' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '/contact' },
];

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' },
  { label: 'Disclaimer', path: '/disclaimer' },
];

const socialLinks = [
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Facebook, href: '#', label: 'Facebook' },
];

export function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (href: string) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      element?.scrollIntoView({ behavior: 'smooth' });
    } else if (href.startsWith('/')) {
      navigate(href);
    }
  };

  return (
    <footer className="py-16 md:py-24 px-4 md:px-8 bg-brand-5">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          <div className="max-w-md">
            <div className="flex items-center gap-2 mb-6">
              <img src="/human_potential_os_logo_V2_cropped.png" alt="Human Potential OS" className="h-14" />
            </div>
            <p className="text-paragraph-lg text-gray-60 mb-6">
              Building a growth mindset starts with understanding yourself — and
              Human Potential OS is here to guide you every step of the way.
            </p>
            <nav className="flex flex-wrap gap-6">
              {navigationLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => handleNavClick(link.href)}
                  className="text-md font-semibold text-gray-60 hover:text-brand-60 transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="flex flex-col sm:flex-row gap-8">
            <div>
              <h4 className="font-bold text-gray-80 mb-4">Legal</h4>
              <div className="space-y-3">
                {legalLinks.map((link) => (
                  <button
                    key={link.label}
                    onClick={() => navigate(link.path)}
                    className="block text-gray-60 hover:text-brand-60 transition-colors"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-gray-20" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8">
          <p className="text-sm text-gray-40">
            Copyright 2025 Human Potential OS, All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-10 text-gray-60 hover:bg-brand-10 hover:text-brand-60 transition-colors"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
